const en = {
  kicker: "Test version",
  title: "Play Trollfossjakten now with Expo Go.",
  lead: "We're testing the app and finalising partnership agreements. The full app launches in the App Store and Google Play by 1 February 2027. Until then you can play the test version for free.",
  notice: "Test version — things may change before launch",
  step1: "Install Expo Go",
  step1Body: "Expo Go is a free app that runs our test version. Get it from your app store.",
  step2: "Scan the code",
  step2Body: "iPhone: scan the code with the Camera app. Android: open Expo Go and tap “Scan QR code”.",
  step3: "Or open the link on your phone",
  step3Body: "Already have Expo Go? Tap the button on your phone to open the test version directly.",
  open: "Open in Expo Go",
  copyLink: "Copy link",
  copied: "Link copied",
  qrAlt: "QR code for the Trollfossjakten test app",
  dlTitle: "Download the test version",
  dlExpo: "1 · Get Expo Go (free)",
  dlOpen: "2 · Open our test app",
  dlLink: "Direct link",
  qrCaption: "Scan to open the test version",
};

export default en;
